import * as React from "react";

const PublisherStagingBanner: React.FC = () => {
  return (
    <div className="bg-attention-soft header-h4 absolute top-0 left-0 w-full p-2.5 text-center font-bold">
      🚧 Using Publisher Staging 🚧
    </div>
  );
};

export default PublisherStagingBanner;
